// extracted by mini-css-extract-plugin
export default {"JoinMeetingButton":"JoinMeetingButton-module-e3c95c9b383ec2cf0ce6"};